

function FullScreenOptionPicker( 
    { title, className, options, optionsClassName, cancelText, onCancel, onSelected } : 
    { title: string, className: string, options: string[], optionsClassName: string, cancelText:string,  onCancel: () => void, onSelected: (item: string) => void }) {

    return (
        <div className={className}>
            <div>{title}</div>
                {options.map((option, index) =>
                    <div>
                        <div key={index} onClick={() => onSelected(option)} className={optionsClassName}>{option}</div>
                    </div>
                )}
                <div onClick={onCancel}>{cancelText}</div>
        </div>
    )

}

export default FullScreenOptionPicker;